var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H37.9973C43.5202 0 47.9973 4.47715 47.9973 10V37.9973C47.9973 43.5202 43.5202 47.9973 37.9973 47.9973H10C4.47715 47.9973 0 43.5202 0 37.9973V10Z",
    fill: "#D0438D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9941 20.9999C14.7895 20.9999 15.5522 21.3159 16.1146 21.8782C16.677 22.4406 16.9929 23.2034 16.9929 23.9987C16.9929 24.794 16.677 25.5567 16.1146 26.1191C15.5522 26.6815 14.7895 26.9974 13.9941 26.9974V28.9966C13.9941 29.5268 14.2048 30.0353 14.5797 30.4102C14.9546 30.7851 15.4631 30.9958 15.9933 30.9958H31.9866C32.5169 30.9958 33.0254 30.7851 33.4003 30.4102C33.7752 30.0353 33.9858 29.5268 33.9858 28.9966V26.9974C33.1905 26.9974 32.4278 26.6815 31.8654 26.1191C31.303 25.5567 30.9871 24.794 30.9871 23.9987C30.9871 23.2034 31.303 22.4406 31.8654 21.8782C32.4278 21.3159 33.1905 20.9999 33.9858 20.9999V19.0008C33.9858 18.4705 33.7752 17.962 33.4003 17.5871C33.0254 17.2122 32.5169 17.0016 31.9866 17.0016H15.9933C15.4631 17.0016 14.9546 17.2122 14.5797 17.5871C14.2048 17.962 13.9941 18.4705 13.9941 19.0008V20.9999Z",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9896 17.0016V19.0016",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9896 28.9966V30.9966",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9896 22.9991V24.9991",
    stroke: "white",
    strokeWidth: 1.99917,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/Bookings.7947c7251bd637abe1a93af6680120e3.svg";
export { ForwardRef as ReactComponent };